import type { QueryKey } from '@tanstack/react-query';

const queryKeys = {
  allCreatives: ['api', 'v1', 'creative_manager', 'get_creatives'] as QueryKey,
  creatives: <TParams>(params?: TParams) => ['api', 'v1', 'creative_manager', 'get_creatives', params] as QueryKey,
  allCreativesWithHypothesis: ['api', 'v1', 'creative_manager', 'get_creatives_with_hypothesis'] as QueryKey,
  creativesWithHypothesis: <TParams>(params?: TParams) =>
    ['api', 'v1', 'creative_manager', 'get_creatives_with_hypothesis', params] as QueryKey,
};
export default queryKeys;